<script>
	export let name;
</script>

<main>
	<div class="split left">
		<div class="centered">
			<p>“Just as electricity transformed almost everything 100 years ago, today I actually have a hard time thinking of an industry that I don’t think AI will transform in the next several years.”<br>- Andrew Ng<br><br><br>
			<p>A new era for real world AI<br><br>
			<address style="color:#d31c3a">Reach us at <a href="mailto:hello@variables.ai">hello@variables.ai</a>.</address>
		</div>
	</div>

	<div class="split right">
		<div class="centered">
			<img src="static/img/variablesai_logo.svg" width=512 height=512 alt="Variables Ai">
			<!-- <h1>Variables {name}</h1> -->
		</div>
	</div>
</main>

<style>
	@font-face {
	    font-family: 'MatryoshkaS';
	    src: url('/static/fonts/matryoshka_s.ttf');
	}

	@font-face {
		font-family: 'YoungSerif';
		src: url('/static/fonts/YoungSerif-Regular.otf');
	}

	main {
		text-align: center;
		padding: 12em;
		max-width: 300px;
		margin: 0 auto;
	}

	.split {
		height: 100%;
		width: 50%;
		position: fixed;
		z-index: 1;
		top: 0;
		overflow-x: hidden;
		padding-top: 20px;
	}

	/* Control the left side */
	.left {
		left: 0;
		background-color: #ffebd2;
	}

	/* Control the right side */
	.right {
		right: 0;
		background-color: #d31c3a;
	}

	/* If you want the content centered horizontally and vertically */
	.centered {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		text-align: center;
	}

	#bottom {
		position: absolute;
		bottom: 0;
		left: 0;
	}

	h1 {
		color: #ffebd2;
		font-family: "MatryoshkaS", Times, serif;
		font-size: 5em;
		font-weight: 100;
		margin: 0 auto;
	}

	img {
 		border-radius: 50%;
	}

	 p{
		color: #d31c3a;
		font-family: 'YoungSerif', Times, serif;
		font-size: 1.75em;
		max-width: 512px;
		margin: 0 auto;
	}

	address {
		font-family: 'YoungSerif', Times, serif;
		/*font-size: 1.75em;*/
	}

	@media (min-width: 640px) {
		main {
			max-width: none;
		}
	}
</style>